module.exports = __webpack_public_path__ + "img/horseback-riding-2.19a6cce1.jpg";